import css from '@styled-system/css';
import { getBox } from "../../primitives";

var _getBaseStyle = function _getBaseStyle() {
  return css({
    backgroundColor: 'grey.900',
    color: 'white',
    borderRadius: '2px',
    border: '1px solid black',
    borderColor: 'grey.900',
    boxShadow: 'normal',
    display: 'flex',
    flexDirection: 'column',
    padding: '4px',
    transition: 'opacity 0.2s ease',
    zIndex: 'highest',
    fontSize: '11px'
  });
};

export var TooltipContainer = getBox(_getBaseStyle);